import { Injectable } from '@angular/core';

import { DataService } from '../../data.service';
import { SupporterEditDto, Team } from '../../shared/model';

import { Observable } from 'rxjs';

@Injectable()
export class TeamsViewService {

    constructor(private dataService: DataService) { }

    getTeamsWithMembers(): Observable<any> {
        return this.dataService.get('Team/GetTeamsWithMembers', {});
    }

    getTeams(): Observable<any> {
        return this.dataService.get('Team/GetTeams', {});
    }

    addTeam(team: Team): Observable<any> {
        return this.dataService.put('Team/AddTeam', team);
    }

    addSupporter(supporter: SupporterEditDto): Observable<any> {
        return this.dataService.put('Supporter/AddSupporter', supporter);
    }

    getTechnicians(): Observable<any> {
        return this.dataService.get('Supporter/Comada/Technicians', {});
    }

    deleteSupporter(supporterId: string): Observable<any> {
        return this.dataService.delete('Supporter/DeleteSupporter', {supporterId: supporterId});
    }

    deleteTeam(teamId: string): Observable<any> {
        return this.dataService.delete('Team/DeleteTeam', {teamId: teamId});
    }

    editTeam(team: Team): Observable<any> {
        return this.dataService.post('Team/EditTeam', team);
    }

    editSupporter(supporter: SupporterEditDto): Observable<any> {
        return this.dataService.post('Supporter/EditSupporter', supporter);
    }

    notifySupporter(supporterId: string): Observable<any> {
        return this.dataService.post('Supporter/NotifySupporterProfile', JSON.stringify(supporterId));
    }
}
